interface IIndeterminateTeamMembersColours {
    memberIcon: string;
}

export const indeterminateTeamMemberColours: IIndeterminateTeamMembersColours = {
    memberIcon: "#cacaca"
};
